import React from 'react'
import { Link } from 'react-router-dom'
import styledComponents from '../styles/InfoContainer-style.js'
const { Container, InfoBoxWrapper, InfoBox, InfoBoxCircle, MudIcon, InfoBoxTitle, InfoBoxDesc } = styledComponents;

const InfoContainer = () => {
    return (
        <Container>
            {/* <Wave alt="BlueCarbon" src="./images/waves.svg" /> */}
            {/* <WaveVertical alt="BlueCarbon" src="./images/wave_vertical.svg" /> */}
            <InfoBoxWrapper>
                {/* MudHome */}
                <Link to={{
                    pathname: '/home',
                    state: {
                        menuId: 0
                    }
                }} >
                    <InfoBox>
                        <InfoBoxCircle >
                            <MudIcon alt="갯벌" src="./images/a_icon.png" />
                        </InfoBoxCircle>
                        <InfoBoxTitle >
                            갯벌
                        </InfoBoxTitle>
                        <InfoBoxDesc>
                            대한민국은 세계자연유산에 등재된 갯벌을 포함해 풍부한 블루카본 자원을 보유하고 있어요.
                        </InfoBoxDesc>
                    </InfoBox>
                </Link>



                {/* Salt Home */}
                <Link to={{
                    pathname: '/home',
                    state: {
                        menuId: 2
                    }
                }} >
                    <InfoBox>
                        <InfoBoxCircle >
                            <MudIcon alt="염습지" src="./images/b_icon.png" />
                        </InfoBoxCircle>
                        <InfoBoxTitle >
                            염습지
                        </InfoBoxTitle>
                        <InfoBoxDesc>
                            연안지역에 주로 분포하는 염습지는 연간 1㎢당 91톤의 탄소를 토양에 저장해요.
                        </InfoBoxDesc>
                    </InfoBox>
                </Link>

                {/* SeaWeed Home */}
                <Link to={{
                    pathname: '/home',
                    state: {
                        menuId: 1
                    }
                }} >
                    <InfoBox>
                        <InfoBoxCircle >
                            <MudIcon alt="해초대" src="./images/c_icon.png" />
                        </InfoBoxCircle>
                        <InfoBoxTitle >
                            해초대
                        </InfoBoxTitle>
                        <InfoBoxDesc>
                            바다 속에서 꽃을 피우는 뿌리식물 서식지인 해초대는 연간 1㎢당 43톤의 탄소를 토양에 저장해요.
                        </InfoBoxDesc>
                    </InfoBox>
                </Link>

            </InfoBoxWrapper>

        </Container>
    )
}

export default InfoContainer;